import type { ReactNode } from 'react';

interface UnauthenticatedLayoutProps {
  children: ReactNode;
}

export const UnauthenticatedLayout = ({ children }: UnauthenticatedLayoutProps) => {
  return (
    <main className="mgo-cluster mgo-align-center mgo-justify-center" style={{ minHeight: '100vh', background: 'var(--mgo-color-bg-neutral-soft-unbordered)', padding: 'var(--mgo-space-80) var(--mgo-space-40)' }}>
      {children}
    </main>
  );
};
